export default __webpack_public_path__ + "static/media/changepass_icon.94684844.png";